import React from 'react';
import { useAppSelector } from 'core/store';
import DashboardPieChart from 'pages/Dashboard/shared/DashboardPieChart';
import { prepareChartData } from '@dashboardWirelineRetentionDepartment/utilities';

interface IRenewedEngagementsChart {
    selectedProducts: string[]
}

const DeclinedEngagementsChart: React.FC <IRenewedEngagementsChart> = (
  { selectedProducts },
) => {
  const declinedEngagementsData = useAppSelector(
    (state) => state.dashboard.declinedEngagements.data,
  );
  const isLoading = useAppSelector(
    (state) => state.dashboard.declinedEngagements.isLoading,
  );

  const { chartData, colors } = prepareChartData(selectedProducts, declinedEngagementsData);

  return (
    <DashboardPieChart
      colors={colors}
      data={chartData}
      isLoading={isLoading}
      innerRadius={60}
      paddingAngle={2}
    />
  );
};

export default DeclinedEngagementsChart;
